/**
 * Pagination display math shared by table pagination controls, clamped so a stale
 * `currentPage` (e.g. the filter narrowed `totalItems` while the user sat on a late
 * page) can never render an inverted range like `21-5 of 5`. Display-side only: the
 * stored page is not corrected here — prev/next navigate from `clampedPage`, so the
 * next click lands back in range.
 */
export interface PageRange {
  /** 1-based first row of the page; `0` when there are no rows. */
  start: number;
  /** 1-based last row of the page; `0` when there are no rows. */
  end: number;
  totalPages: number;
  /** `currentPage` clamped to `[1, totalPages]` — what the range and controls render from. */
  clampedPage: number;
}

export function getPageRange(currentPage: number, itemsPerPage: number, totalItems: number): PageRange {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const clampedPage = Math.min(Math.max(1, currentPage), totalPages);
  const end = Math.min(clampedPage * itemsPerPage, totalItems);
  const start = end ? (clampedPage - 1) * itemsPerPage + 1 : 0;
  return { start, end, totalPages, clampedPage };
}
